// https://date-fns.org/docs/parse
import parseDate from 'date-fns/parse'
// https://date-fns.org/docs/format
import format from 'date-fns/format'
// https://date-fns.org/docs/distanceInWords
import distanceInWords from 'date-fns/distance_in_words'
// https://date-fns.org/docs/isToday
import isToday from 'date-fns/is_today'

export function formatDate(date) {
  date = parseDate(date)
  return format(date, 'MMM Do, YYYY')
}
export function formatPrettyDate(date) {
  date = parseDate(date)
  return format(date, 'ddd DD MMM YYYY')
}
export function formatPrettyDateTime(date) {
  date = parseDate(date)
  return format(date, 'hh:mm:s a ddd DD MMM YYYY ')
}
export function formatPrettyDateTimeshort(date) {
  date = parseDate(date)
  return format(date, 'hh:mm:sa ddd DD MMM ')
}
export function formatWebDate(date) {
  date = parseDate(date)
  return format(date, 'YYYY-MM-DD')
}
export function getDateAtMidnight(date) {
  date = new Date(date).setUTCHours(0, 0, 0, 0)
  return date
}
export default function formatDateRelative(fromDate, toDate = new Date()) {
  fromDate = parseDate(fromDate)
  toDate = parseDate(toDate)
  return distanceInWords(fromDate, toDate) + (isToday(toDate) ? ' ago' : '')
}

export function getDateTimeWithLocalOffsetAsISO(date) {
  var tzoffset = date.getTimezoneOffset() * 60000 // offset in milliseconds
  var localISOTime = new Date(date.getTime() - tzoffset)
    .toISOString()
    .slice(0, 19)
    .replace('T', ' ')
  var mySqlDT = localISOTime
  return mySqlDT
}

// Domain
export function durationSinceEvent(moment, startDate) {
  let endDate = Date.now()
  let minutes = moment
    .utc(moment.duration(moment(endDate).diff(moment(startDate))).asMilliseconds())
    .format('HH:mm:ss')

  return minutes
}

export function futureTimeOfEvent(moment, startDate, duration) {
  let futureTimeOfEvent = moment(startDate).add(duration, 'minutes')
  return futureTimeOfEvent
}

export function durationOfEvent(moment, startDate, endDate) {
  let minutes = moment
    .utc(moment.duration(moment(endDate).diff(moment(startDate))).asMilliseconds())
    .format('HH:mm:ss')

  return minutes
}

export function durationOfEventSeconds(moment, startDate, endDate) {
  let minutes = moment.duration(moment(endDate).diff(moment(startDate))).asSeconds()

  return minutes
}

export function prettyMinutes(moment, minutes) {
  // const formatted = moment.utc(secs*1000).format('HH:mm:ss');
  return moment
    .utc(minutes * 60 * 1000)

    .format('HH:mm:ss')
}

export function sortArrayOfDates(arrayOfDates) {
  return arrayOfDates.sort((a, b) => a.getTime() - b.getTime())
}
